<template>
  <div class="rows-layout" :style="containerStyle">
    <GalleryItem v-for="(image, index) in images" :key="image.id" :image="image" :is-loaded="loadedImages[image.id]"
      :container-style="itemStyle(image)" :loading="index < columns * 4 ? 'eager' : 'lazy'" :fetch-priority="index < columns * 2 ? 'high' : 'auto'"
      img-mode="cover"
      v-bind="appearance" @click="$emit('item-click', $event)" @load="$emit('image-load', $event)" />
  </div>
</template>

<script>
import GalleryItem from '../GalleryItem.vue'
import { PHONE_MAX_HEIGHT_RATIO } from './phoneCap'

export default {
  name: 'RowsLayout',

  components: { GalleryItem },

  props: {
    images: { type: Array, required: true },
    loadedImages: { type: Object, required: true },
    imageAspectRatios: { type: Object, required: true },
    columns: { type: Number, default: 4 },
    gap: { type: Number, default: 15 },
    rowHeight: { type: Number, default: 200 },
    containerWidth: { type: Number, default: 0 },
    appearance: { type: Object, default: () => ({}) }
  },

  emits: ['item-click', 'image-load'],

  computed: {
    containerStyle() {
      return {
        display: 'flex',
        flexWrap: 'wrap',
        justifyContent: 'space-evenly',
        gap: this.gap + 'px',
        alignItems: 'flex-start'
      }
    }
  },

  methods: {
    itemStyle(image) {
      const aspectRatio = this.imageAspectRatios[image.id] || 1
      const w = this.containerWidth
      if (this.columns === 1 && w > 0) {
        // Phone: one uncropped artwork per row, tall works capped and centred
        const width = Math.min(w, w * PHONE_MAX_HEIGHT_RATIO * aspectRatio)
        const side = (w - width) / 2 + 'px'
        return { width: width + 'px', height: width / aspectRatio + 'px', marginLeft: side, marginRight: side }
      }
      const naturalWidth = this.rowHeight * aspectRatio
      let maxW
      if (w > 0 && w <= 768) {
        // 2 items per row on tablet; CSS-relative so they never overflow mid-resize
        maxW = `calc((100% - ${this.gap}px) / 2)`
      } else {
        maxW = naturalWidth * 1.3 + 'px'   // natural + 30% growth on desktop
      }
      return {
        height: this.rowHeight + 'px',
        width: `min(${naturalWidth}px, ${maxW})`,
        flexGrow: 1,
        flexShrink: 0,
        maxWidth: maxW
      }
    }
  }
}
</script>

<style scoped>
.rows-layout {
  width: 100%;
}
</style>
